/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiDefApiConfiguration } from '../api-def-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiDefUserData } from '../models/api-def-user-data';
import { usersDeleteUserById } from '../fn/users/users-delete-user-by-id';
import { UsersDeleteUserById$Params } from '../fn/users/users-delete-user-by-id';
import { usersGetUserById } from '../fn/users/users-get-user-by-id';
import { UsersGetUserById$Params } from '../fn/users/users-get-user-by-id';
import { usersGetUsers } from '../fn/users/users-get-users';
import { UsersGetUsers$Params } from '../fn/users/users-get-users';
import { usersUpdateUserById } from '../fn/users/users-update-user-by-id';
import { UsersUpdateUserById$Params } from '../fn/users/users-update-user-by-id';


/**
 * User management operations
 */
@Injectable({ providedIn: 'root' })
export class UsersService extends BaseService {
  constructor(config: ApiDefApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `usersGetUsers()` */
  static readonly UsersGetUsersPath = '/users';

  /**
   * Get list of users.
   *
   * Get a paginated list of users, with optional filters and search by name
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersGetUsers()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGetUsers$Response(params?: UsersGetUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'users'?: Array<ApiDefUserData>;

/**
 * Total number of users matching the query
 */
'total'?: number;
}>> {
    return usersGetUsers(this.http, this.rootUrl, params, context);
  }

  /**
   * Get list of users.
   *
   * Get a paginated list of users, with optional filters and search by name
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersGetUsers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGetUsers(params?: UsersGetUsers$Params, context?: HttpContext): Observable<{
'users'?: Array<ApiDefUserData>;

/**
 * Total number of users matching the query
 */
'total'?: number;
}> {
    return this.usersGetUsers$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'users'?: Array<ApiDefUserData>;

/**
 * Total number of users matching the query
 */
'total'?: number;
}>): {
'users'?: Array<ApiDefUserData>;

/**
 * Total number of users matching the query
 */
'total'?: number;
} => r.body)
    );
  }

  /** Path part for operation `usersGetUserById()` */
  static readonly UsersGetUserByIdPath = '/users/{id}';

  /**
   * Get a user by ID.
   *
   * Retrieve a user by their ID
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersGetUserById()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGetUserById$Response(params: UsersGetUserById$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiDefUserData>> {
    return usersGetUserById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a user by ID.
   *
   * Retrieve a user by their ID
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersGetUserById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGetUserById(params: UsersGetUserById$Params, context?: HttpContext): Observable<ApiDefUserData> {
    return this.usersGetUserById$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiDefUserData>): ApiDefUserData => r.body)
    );
  }

  /** Path part for operation `usersDeleteUserById()` */
  static readonly UsersDeleteUserByIdPath = '/users/{id}';

  /**
   * Delete a user by ID.
   *
   * Delete a user by their ID
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersDeleteUserById()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersDeleteUserById$Response(params: UsersDeleteUserById$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return usersDeleteUserById(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a user by ID.
   *
   * Delete a user by their ID
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersDeleteUserById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersDeleteUserById(params: UsersDeleteUserById$Params, context?: HttpContext): Observable<void> {
    return this.usersDeleteUserById$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `usersUpdateUserById()` */
  static readonly UsersUpdateUserByIdPath = '/users/{id}';

  /**
   * Update a user by ID.
   *
   * Partially update a user by their ID
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersUpdateUserById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersUpdateUserById$Response(params: UsersUpdateUserById$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiDefUserData>> {
    return usersUpdateUserById(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a user by ID.
   *
   * Partially update a user by their ID
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersUpdateUserById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersUpdateUserById(params: UsersUpdateUserById$Params, context?: HttpContext): Observable<ApiDefUserData> {
    return this.usersUpdateUserById$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiDefUserData>): ApiDefUserData => r.body)
    );
  }

}
